export default function createFakeEvent(targetValue, e = {}, dataset) {
  const fake = { ...e };

  // TODO find out why these are not cloned from the ...e above. Is it due to React's syntetic events?
  fake.altKey = e.altKey;
  fake.ctrlKey = e.ctrlKey;
  fake.metaKey = e.metaKey;
  fake.shiftKey = e.shiftKey;
  fake.key = e.key;
  fake.target = e.target ? { ...e.target } : {};
  fake.target.value = targetValue;
  fake.target.getAttribute = fake.target.getAttribute || (() => {});
  fake.target.dataset = dataset || (e.target && e.target.dataset);
  fake.currentTarget = e.currentTarget;
  fake.preventDefault = () => e.preventDefault && e.preventDefault();
  fake.stopPropagation = () => e.stopPropagation && e.stopPropagation();
  fake.stopPropagation = () => e.stopPropagation && e.stopPropagation();
  fake.type = e.type;
  return fake;
}
